/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useEffect, useState } from 'react'
// import { uploadFile } from 'react-s3';
import { Uploadconfig } from '../../redux/helper/upload-config';
import ThreeDotsLoader from '../LoadingDots';
import Spinner from '../Spinner';
import { uploadFileToS3 } from '../../redux/helper/s3Upload';
import { creatUUId } from '../../redux/helper/CreateUUID';
import { distributorService } from '../../service/distributor.service';
// const Buffer =  Array;
// window.Buffer = window.Buffer || require('buffer').Buffer;

export default function DocumentModal(
    { setdocumentModal,
        documentModal,
        documentData,
        setdocument,
        handleSubmit,
        loader,
        orderFlow,
        isdraft,
        setloader,
        restrictOrder,
        adorCashCheck,
        Calculation,
        type,
        restrictTradeEUBOrder
    }) {
    const [spinner, setspinner] = useState('');
    const [PoError, setPoError] = useState('')
    const [instructionError, setInstructionError] = useState('')
    const [restriction, setRestriction] = useState(false)
    const handleDocValues = (val, key) => {
        setdocument((prev) => ({
            ...prev,
            [key]: val
        }))
    }
    const handleUploadedFiles = (val, key) => {
        const data = { ...documentData };
        const idx = data[key].indexOf(val)
        if (idx > -1) {
            data[key].splice(idx, 1)
        } else {
            data[key].push(val)
        }
        setdocument(data);
        setspinner('')

    }
    // instruction:'',
    //     PO_details:'',
    //     attach_po:[],
    //     attach_file:[]


    const handleUploadDoc = async (e, key) => {
        const files = e.target.files;
        setspinner(true);
    
        if (!files || files.length === 0) {
            setspinner(false);
            return;
        }
        try {
            let nameKey = `eub/${creatUUId()}/${files[0].name}`
            const fileUrl = await distributorService.uploadImages(nameKey, files[0])
            const keyPath = fileUrl.split('.com/')[1]; // get the path for storing in backend
            await distributorService.getSignedUrl(keyPath,'get');
            handleUploadedFiles(keyPath, key);
        } catch (err) {
            console.error("S3 Upload Error:", err);
            handleErrorMessage("File upload failed");
        } finally {
            setspinner(false);
        }
    };
    const checkLength = (words) => {
        return words?.length <= 250;
    }
    const handleChange = (e) => {
        const value = e.target.value;
        if (checkLength(value)) {
            setInstructionError('');
            handleDocValues(value, 'instruction');
        } else {
            setInstructionError('The text exceeds the 250 character limit.');
            // setTimeout(() => {
            //     setInstructionError('');
            // }, 3000);
            const trimmedValue = value
            handleDocValues(trimmedValue, 'instruction');
        }
    };
    const handleAmount = (value) => {
        const number = Number(value)?.toLocaleString('en-IN', {
            style: 'currency',
            currency: 'INR',
        })
        return number
    }
    useEffect(() => {
        function checkRestriction() {
            if (orderFlow?.order_type === 'Trade Order') {

                if (!adorCashCheck) {
                    return Calculation?.restrict_order;
                } else {
                    return Calculation?.restrict_ador_cash_order;
                }
            } else {
                if (!adorCashCheck) {
                    return Calculation?.restrict_trade_eub_order;
                } else {
                    return Calculation?.restrict_ador_cash_trade_eub_order;
                }
            }
        }
        setRestriction(checkRestriction())
    }, [Calculation, adorCashCheck, orderFlow])
    return (
        <div className={`modal fade fixed top-0 left-0 ${documentModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="addDocumnetation" tabIndex="-1" aria-labelledby="addDocumnetation" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative lg:max-w-[480px] lg:min-w-[443px] w-full px-3 pointer-events-none" style={{ margin: 'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col pointer-events-auto w-full bg-white border border-[#707070] bg-clip-padding rounded-md outline-none text-current md:px-[30px] sm:px-4 px-3 sm:pt-[32px] pt-4 pb-5">
                    <div>
                        {!restriction ?
                            <div>
                                <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative">
                                    <h5 className="sm:text-xl text-lg font-semibold leading-normal text-[#090406]" id="exampleModalScrollableLabel">
                                        Documentation
                                    </h5>
                                    <button onClick={() => setdocumentModal(false)} type="button" className="absolute top-0 right-0" data-bs-dismiss="modal" aria-label="Close">
                                        <img src="/images/Icon-ionic-ios-close.svg" alt="" />
                                    </button>
                                </div>
                                <div className="modal-body pt-[22px]">
                                    <div className="relative">
                                        <label htmlFor="inp" className="text-base font-semibold text-[#555259]">Instructions</label>
                                        <textarea
                                            onChange={(e) => {
                                                handleChange(e)
                                                // 
                                                // if (checkLength())
                                                // handleDocValues(e.target.value, 'instruction')

                                            }}
                                            value={documentData.instruction}
                                            name="enterMoremessage" id="inp" className="w-full h-[108px] resize-none px-[13px] py-[14px] border border-[#707070] rounded-lg mt-3 sm:text-base text-xs6 font-normal text-[#000000] placeholder:text-base placeholder:text-[#808285] placeholder:font-normal outline-none custom-scrollbar" placeholder="Enter specific instructions or comment (if any)"></textarea>
                                        <p className="absolute bottom-[3px] right-5 px-1 bg-[#FFFFFF] text-xs13 font-normal text-[#808285]">
                                            {/* {500 - documentData.instruction.split(' ').length+1} {documentData.instruction.split(' ').length===1 && 'words'} */}
                                            250 characters
                                        </p>
                                    </div>
                                    {instructionError !== '' && <div className="flex items-center uploaded-err">
                                        <p className="pl-1 text-xs3 font-normal text-[#ED1C24]">Your input exceeds the allowed character limit. Please upload a file to include all your details.
                                        </p>
                                    </div>}
                                    <>{orderFlow.order_type === 'Trade EUB Order' &&
                                        <>
                                            <p className="text-base font-semibold text-[#555259] mt-[18px]">PO Details</p>
                                            <div className="mt-2">
                                                <label htmlFor="ponumber" className="text-xs13 font-normal text-[#555259]">PO Number*</label>
                                                <input
                                                    style={{ border: `${PoError === 'PO_details' ? '1px solid red' : ''}` }}
                                                    onFocus={() => setPoError('')}
                                                    onChange={(e) => handleDocValues(e.target.value, 'PO_details')}
                                                    value={documentData.PO_details}
                                                    type="text" className="mt-2 w-full border border-[#707070] rounded-lg text-base font-normal text-[#000000] py-[13px] outline-0 px-[13px] placeholder:text-base placeholder:text-[#808285] placeholder:font-normal" placeholder="Enter PO Number" />
                                            </div>
                                            {PoError === 'PO_details' && <div className="flex items-center uploaded-err">
                                                <p className="pl-1 text-xs3 font-normal text-[#ED1C24]">PO Number is mandatory</p>
                                            </div>}
                                            {/* <!-- showing uploaded file --> */}
                                            {documentData.attach_po?.map((item) => (
                                                <div className="mt-3.5 flex items-center file-uploaded" key={item}>
                                                    <span className='flex'><img src="/images/doc.svg" alt="uploaded-img" className='mr-1' />{item.split('/').at(-1)}</span>
                                                    <span className="ml-2.5">
                                                        <img src="/images/circle-close.svg" alt="close-icon" className="cursor-pointer" onClick={() => {
                                                            handleUploadedFiles(item, 'attach_po')
                                                        }} />
                                                    </span>
                                                </div>
                                            ))}
                                            <div className="relative mt-3 mb-1 cursor-pointer">
                                                <input type="file" onChange={(e) => handleUploadDoc(e, 'attach_po')} className="opacity-0 absolute top-0 left-0 cursor-pointer w-20 h-5" />
                                                <span className='flex'><label htmlFor="file" className="text-sm font-semibold text-[#808285] cursor-pointer" style={{ cursor: 'pointer' }}>+ Attach PO*</label>
                                                    {spinner === 'attach_po' && <Spinner />}</span>
                                            </div>
                                            {PoError === 'attachment' && <div className="flex items-center uploaded-err">
                                                <img src="images/info_icon-red.svg" alt="icon" />
                                                <p className="pl-1 text-xs3 font-normal text-[#ED1C24]">PO details are mandatory</p>
                                            </div>}
                                        </>
                                    }
                                    </>
                                    <p className="sm:text-base text-xs6 font-semibold text-[#555259] mt-2.5 upload">Additional Details</p>
                                    {documentData.attach_file?.map((item) => (
                                        <div className="mt-3.5 flex items-center file-uploaded cursor-pointer" key={item}>
                                            <span className='flex'><img src="/images/doc.svg" alt="uploaded-img" className='mr-1' />{item.split('/').at(-1)}</span>
                                            <span className="ml-2.5">
                                                <img src="/images/circle-close.svg" alt="close-icon" className="cursor-pointer" onClick={() => {
                                                    handleUploadedFiles(item, 'attach_file')
                                                }} />
                                            </span>
                                        </div>
                                    ))}
                                    <div className="relative mt-2.5 mb-1">
                                        <input type="file" className="opacity-0 absolute top-0 left-0 cursor-pointer w-20 h-5" onChange={(e) => handleUploadDoc(e, 'attach_file')} />
                                        <span className='flex'><label htmlFor="file" className="text-sm font-semibold text-[#808285] cursor-pointer" style={{ cursor: 'pointer' }}>+ Attach file</label>
                                            {spinner === 'attach_file' && <Spinner />}</span>
                                    </div>
                                    <div className="pt-[22px] flex justify-center">
                                        <button type="button"
                                            disabled={spinner || PoError !== ''}
                                            onClick={() => {
                                                if (!checkLength(documentData?.instruction)) {
                                                    setInstructionError('error');
                                                    return;
                                                }
                                                if (orderFlow.order_type === 'Trade EUB Order' && documentData.attach_po.length === 0) {
                                                    setPoError('attachment');
                                                    setTimeout(() => {
                                                        setPoError('');
                                                    }, 5000);
                                                    return
                                                } else if (orderFlow.order_type === 'Trade EUB Order' && documentData.PO_details === '') {
                                                    setPoError('PO_details');
                                                    return
                                                } else {
                                                    setloader(true)
                                                    if (isdraft) {
                                                        handleSubmit('key')
                                                    } else {
                                                        handleSubmit()
                                                    }
                                                }
                                            }}
                                            className="w-full sm:w-[306px] sm:py-3.5 py-2 rounded-lg bg-[#555259] sm:text-lg text-base font-semibold text-[#FFFFFF] flex justify-center items-center" data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="modal" data-bs-target="#orderPlaced">
                                            {loader ? <ThreeDotsLoader /> : <>{isdraft ? 'Save Changes' : 'Place Order'}</>}
                                        </button>
                                    </div>
                                </div>
                            </div> :
                            (<div>
                                <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative">
                                    <h5 className="sm:text-xl text-lg font-semibold leading-normal text-[#090406]" id="exampleModalScrollableLabel">
                                        Credit Limit Exceeded
                                    </h5>

                                </div>
                                <div className='mt-6 px-7'>
                                    <div className='w-[364px]'>
                                        <p className='text-[#090406] font-normal text-sm'>
                                            {`The order amount of ${orderFlow?.order_type === 'Trade Order'
                                                ?
                                                (adorCashCheck ? handleAmount(Calculation?.ador_cash_order_gross_amount)
                                                    :
                                                    handleAmount(Calculation?.order_gross_amount))
                                                : (adorCashCheck ? handleAmount(Calculation?.ador_cash_proposed_gross_amount)
                                                    :
                                                    handleAmount(Calculation?.proposed_gross_amount))
                                            }
                                            exceeds the credit balance value ${handleAmount(Calculation.credit_balance)}`}</p>
                                        <p className='text-[#090406] font-normal text-sm'>{`Credit limit value is ${handleAmount(Calculation?.credit_limit)}.`}</p>
                                    </div>
                                    <div className="pt-[22px] flex justify-center">
                                        <button type="button"
                                            onClick={() => setdocumentModal(false)}
                                            className="w-full sm:w-[306px] sm:py-3.5 py-2 rounded-lg bg-[#555259] sm:text-lg text-base font-semibold text-[#FFFFFF] flex justify-center items-center" data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="modal" data-bs-target="#orderPlaced">
                                            OK
                                        </button>
                                    </div>
                                </div>
                            </div>)}
                    </div>
                </div>
            </div>
        </div>
    )
}
